import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Tras cada cambio de ruta, mueve el foco al h1 de la nueva vista
 * para que los lectores de pantalla anuncien la pantalla.
 * El anillo visual se oculta por CSS (foco solo programático / a11y).
 */
@Injectable({ providedIn: 'root' })
export class RouteFocusService {
  private started = false;
  private subscription: Subscription;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  init(): void {
    if (this.started) {
      return;
    }

    this.started = true;
    this.subscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.focusPageTitle());
  }

  destroy(): void {
    this.subscription?.unsubscribe();
    this.started = false;
  }

  private focusPageTitle(): void {
    setTimeout(() => {
      const heading = this.document.querySelector('#main-content h1') as HTMLElement | null;
      if (!heading) {
        return;
      }

      if (!heading.hasAttribute('tabindex')) {
        heading.setAttribute('tabindex', '-1');
      }

      heading.focus({ preventScroll: true });
    });
  }
}
